import VerifyEmailModal from './VerifyEmailModal';

export default VerifyEmailModal;
